/**
 * Xero COA Alignment Exception Config
 *
 * Covers: xero-coa-alignment
 *
 * Routes through the shared compare-table renderer (open-list variant -
 * Aligned / Mismatch / Missing / Extra). The COA backend now emits both
 * the legacy column shape AND the unified ``expected`` / ``found`` /
 * ``field_matches`` / ``issue_text`` payload (see
 * ``backend/shared/exception_display/system_xero_coa.py``), so the
 * shared renderer reads the same envelope the helper-products and dosage
 * tables consume. When the COA backend migrates to ``pwx_masters``
 * (see ``docs/plans/pending/coa-master-migration-to-pwx-masters.md``)
 * no frontend change is needed.
 */
import {
  buildMasterCompareConfig,
  type CompareField,
} from '../shared/masterCompareTable'
import type { ExceptionConfig } from '../types'


const COA_FIELDS: CompareField[] = [
  { key: 'code', label: 'Code' },
  { key: 'name', label: 'Name' },
  { key: 'type', label: 'Type' },
  { key: 'class', label: 'Class' },
  { key: 'tax_type', label: 'Tax type' },
]


export const xeroCoaConfig: ExceptionConfig = {
  ...buildMasterCompareConfig({
    codes: ['xero-coa-alignment'],
    statusSet: 'open',
    compareFields: COA_FIELDS,
    systemLabel: 'Xero',
    rowKeyField: 'xero_account_id',
    // Account code is the join key - identical to master_value, so
    // hide the duplicate Expected Code column in the platform context.
    masterKeyField: 'code',
    // COA stays chip-less for now: its rows key on xero_account_id and the
    // drawer endpoint's COA resolution is unproven. Flip when verified.
    issuesColumn: false,
  }),
}
